import React from 'react';

const HorizontalLine = ({ className = '' }) => {
  const baseClasses = 'border-t border-foreground';
  const combinedClasses = [baseClasses, className].filter(Boolean).join(' ');
  
  return (
    <div className={combinedClasses} />
  );
};

export default HorizontalLine;